import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import {AuthService, IAuthService} from "../../../auth/auth.service";

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next:
  HttpHandlerFn) => {
  const authService: IAuthService = inject(AuthService);

  if (authService.isAuthenticated()) {
    const modifiedReq = req.clone({
      headers: req.headers.set('X-Auth-Token', `${authService.getToken()}`),
    });
    return next(modifiedReq);
  }
  return next(req);
};